import React, { useContext, useEffect, useRef, useState } from "react";
import { NewDataDialog, ExistingDataDialog, MediaChunksDialog, ItemMetadataDialog, IngestMetadataDialog } from "components/Dialogs";
import Input from "components/Elements/Input";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { getAgents } from "../../services/clients";
import {
  getMediaItem,
  updateMediaItem,
  deleteMediaItem,
} from "../../services/media";
import Swal from "sweetalert2";
import { AppContext } from "../../contexts/AppContext";
import { useDataSets } from "../../contexts/DataSetsContext";
import { Button } from "../StyledElements";
import { ingestDataSetItem, saveDataSetItem, deleteDataSetItem, getDataSetItem, getDataSetItemChunks } from "../../services/data";
import swal from "sweetalert2";
import {
  SELECTED_ROW_BACKGROUND,
  UNSELECTED_ROW_BACKGROUND,
  countSelected,
  setSelection,
  toggleRowSelected,
} from "../../utils/dataItemSelection";
import { summarizeMetadata } from "../../utils/metadata";
import { hasMetadataSchema } from "../../utils/datasetMetadata";
import { describeChunkResponse } from "../../utils/mediaChunks";
import MediaPreviewDialog from "../Media/MediaPreviewDialog";

DataTable.use(DT);
const EditMediaModal = NiceModal.create(({ public_id, title = "Media" }) => {
  const [savingMedia, setSavingMedia] = useState(false);
  const [mediaItem, setMediaItem] = useState(null);
  const [additionalData, setAdditionalData] = useState(null);
  const formRef = useRef(null);
  const mediaItemRef = useRef(null);
  const modal = useModal();

  useEffect(() => {
    getMediaItem(public_id).then((item) => {
      console.log("!!! MEDIA ITEM: ", item);
      mediaItemRef.current = JSON.stringify(item);
      if (item?.additional_data) {
        try {
          const d = JSON.parse(item.additional_data);
          setAdditionalData(d);
        } catch (e) {
          console.error("!!! ERROR PARSING JSON: ", e);
        }
      }
      setMediaItem(item);
    });
  }, [public_id]);

  const hide = (e) => {
    modal.remove();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.search("additionalData") > -1) {
      const newName = name.split(".").pop();
      console.log("!!! NAME: ", newName);
      if (newName === "tags") {
        const tags = value.split(",");
        setAdditionalData({ ...additionalData, [newName]: tags });
      } else {
        setAdditionalData({ ...additionalData, [newName]: value });
      }

      setMediaItem({
        ...mediaItem,
        additional_data: JSON.stringify(additionalData),
      });
    } else {
      setMediaItem({ ...mediaItem, [name]: value });
    }
    console.log("CHANGE: ", name, value);
  };

  const save = async (e) => {
    setSavingMedia(true);
    const response = await updateMediaItem(mediaItem);
    console.log("!!! SAVE RESPONSE: ", response);
    const updatedMediaItem = response.success ? response.media : null;
    modal.resolve(updatedMediaItem);
    Swal.fire({
      title: "Success",
      text: "Media item updated successfully",
      icon: "success",
      button: "OK",
      confirmButtonText: "OK",
    }).then((result) => {
      setSavingMedia(false);
      modal.remove();
    });
  };

  return (
    <>
      <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">Edit {mediaItem?.name}</h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div
              className="relative p-6 flex-auto overflow-y-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <form ref={formRef}>
                  <label>ID</label>
                  <Input
                    label="ID"
                    type="text"
                    placeholder="ID"
                    name="id"
                    value={mediaItem?.public_id ?? ""}
                    onChange={handleChange}
                    disabled={true}
                  />
                  <label>Name</label>
                  <Input
                    label="Name"
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={mediaItem?.name ?? ""}
                    onChange={handleChange}
                  />
                  <label>Short Title</label>
                  <Input
                    label="Short Title"
                    type="text"
                    placeholder="Short Title"
                    name="short_title"
                    value={mediaItem?.short_title ?? ""}
                    onChange={handleChange}
                  />
                  <label>Category</label>
                  <Input
                    label="Category"
                    type="text"
                    placeholder="Category"
                    name="additionalData.category"
                    value={additionalData?.category ?? ""}
                    onChange={handleChange}
                  />
                  <label>Tags</label>
                  <Input
                    label="Tags"
                    type="textarea"
                    placeholder="Tags"
                    name="additionalData.tags"
                    value={
                      additionalData?.tags ? additionalData.tags.join(",") : ""
                    }
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Summary</label>
                  <Input
                    label="Summary"
                    type="textarea"
                    placeholder="Summary"
                    name="summary"
                    value={mediaItem?.summary ?? ""}
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Description</label>
                  <Input
                    label="Description"
                    type="textarea"
                    placeholder="Description"
                    name="description"
                    value={mediaItem?.description ?? ""}
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Transcript</label>
                  <Input
                    label="Transcript"
                    type="textarea"
                    placeholder="Transcript"
                    name="transcript"
                    value={mediaItem?.fulltext ?? ""}
                    onChange={handleChange}
                    disabled={true}
                    style={{ height: "300px" }}
                  />
                </form>
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!savingMedia ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={
                  savingMedia ||
                  JSON.stringify(mediaItem) === mediaItemRef.current
                }
                style={{
                  opacity:
                    JSON.stringify(mediaItem) === mediaItemRef.current
                      ? 0.5
                      : 1,
                }}
              >
                {savingMedia ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i>{" "}
                    Processing...
                  </>
                ) : (
                  <>Save</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

NiceModal.register("edit-media-item", EditMediaModal);

const NewMediaModal = NiceModal.create(({ public_id, title = "Media" }) => {
  const [savingMedia, setSavingMedia] = useState(false);
  const [mediaItem, setMediaItem] = useState(null);
  const [additionalData, setAdditionalData] = useState(null);
  const formRef = useRef(null);
  const mediaItemRef = useRef(null);
  const modal = useModal();

  useEffect(() => {
    getMediaItem(public_id).then((item) => {
      console.log("!!! MEDIA ITEM: ", item);
      mediaItemRef.current = JSON.stringify(item);
      if (item?.additional_data) {
        try {
          const d = JSON.parse(item.additional_data);
          setAdditionalData(d);
        } catch (e) {
          console.error("!!! ERROR PARSING JSON: ", e);
        }
      }
      setMediaItem(item);
    });
  }, [public_id]);

  const hide = (e) => {
    modal.remove();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.search("additionalData") > -1) {
      const newName = name.split(".").pop();
      console.log("!!! NAME: ", newName);
      if (newName === "tags") {
        const tags = value.split(",");
        setAdditionalData({ ...additionalData, [newName]: tags });
      } else {
        setAdditionalData({ ...additionalData, [newName]: value });
      }

      setMediaItem({
        ...mediaItem,
        additional_data: JSON.stringify(additionalData),
      });
    } else {
      setMediaItem({ ...mediaItem, [name]: value });
    }
    console.log("CHANGE: ", name, value);
  };

  const save = async (e) => {
    setSavingMedia(true);
    const response = await updateMediaItem(mediaItem);
    console.log("!!! SAVE RESPONSE: ", response);
    const updatedMediaItem = response.success ? response.media : null;
    modal.resolve(updatedMediaItem);
    Swal.fire({
      title: "Success",
      text: "Media item updated successfully",
      icon: "success",
      button: "OK",
      confirmButtonText: "OK",
    }).then((result) => {
      setSavingMedia(false);
      modal.remove();
    });
  };

  return (
    <>
      <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-full my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-3xl font-semibold">New Media</h3>
              <button
                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={hide}
              >
                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div
              className="relative p-6 flex-auto overflow-y-auto"
              style={{ maxHeight: "70vh" }}
            >
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <form ref={formRef}>
                  <label>ID</label>
                  <Input
                    label="ID"
                    type="text"
                    placeholder="ID"
                    name="id"
                    value={mediaItem?.public_id ?? ""}
                    onChange={handleChange}
                    disabled={true}
                  />
                  <label>Name</label>
                  <Input
                    label="Name"
                    type="text"
                    placeholder="Name"
                    name="name"
                    value={mediaItem?.name ?? ""}
                    onChange={handleChange}
                  />
                  <label>Short Title</label>
                  <Input
                    label="Short Title"
                    type="text"
                    placeholder="Short Title"
                    name="short_title"
                    value={mediaItem?.short_title ?? ""}
                    onChange={handleChange}
                  />
                  <label>Category</label>
                  <Input
                    label="Category"
                    type="text"
                    placeholder="Category"
                    name="additionalData.category"
                    value={additionalData?.category ?? ""}
                    onChange={handleChange}
                  />
                  <label>Tags</label>
                  <Input
                    label="Tags"
                    type="textarea"
                    placeholder="Tags"
                    name="additionalData.tags"
                    value={
                      additionalData?.tags ? additionalData.tags.join(",") : ""
                    }
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Summary</label>
                  <Input
                    label="Summary"
                    type="textarea"
                    placeholder="Summary"
                    name="summary"
                    value={mediaItem?.summary ?? ""}
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Description</label>
                  <Input
                    label="Description"
                    type="textarea"
                    placeholder="Description"
                    name="description"
                    value={mediaItem?.description ?? ""}
                    onChange={handleChange}
                    style={{ height: "120px" }}
                  />
                  <label>Transcript</label>
                  <Input
                    label="Transcript"
                    type="textarea"
                    placeholder="Transcript"
                    name="transcript"
                    value={mediaItem?.fulltext ?? ""}
                    onChange={handleChange}
                    disabled={true}
                    style={{ height: "300px" }}
                  />
                </form>
              </div>
            </div>
            <div className="relative p-6 flex-auto"></div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              {!savingMedia ? (
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              ) : null}
              <button
                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={save}
                disabled={
                  savingMedia ||
                  JSON.stringify(mediaItem) === mediaItemRef.current
                }
                style={{
                  opacity:
                    JSON.stringify(mediaItem) === mediaItemRef.current
                      ? 0.5
                      : 1,
                }}
              >
                {savingMedia ? (
                  <>
                    <i className="fas fa-circle-notch fa-spin"></i>{" "}
                    Processing...
                  </>
                ) : (
                  <>Save</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
});

NiceModal.register("new-media-item", NewMediaModal);

const MediaTable = ({ media = [], isDataSet = false, hideTitle = false, hideButtons = false, showAddExisting = false, mode = null, onSelect = () => { }, onSelectSave = null }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [showExistingDialog, setShowExistingDialog] = useState(false);
  const [showMediaChunksDialog, setShowMediaChunksDialog] = useState(false);
  const [chunksEmptyMessage, setChunksEmptyMessage] = useState(null);
  const [showItemMetadataDialog, setShowItemMetadataDialog] = useState(false);
  const [metadataItem, setMetadataItem] = useState(null);
  const [ingestItem, setIngestItem] = useState(null);
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);
  const { selectedClient } = useContext(AppContext);
  const tableRef = useRef(null);
  const containerRef = useRef(null);
  const selectedCountRef = useRef(null);
  let tokenCount = 0;
  const [localMedia, setLocalMedia] = useState(media);
  const [mediaChunks, setMediaChunks] = useState(null);
  const [mediaTitle, setMediaTitle] = useState();
  const [deleting, setDeleting] = useState(false);
  const { removeDataSetItem, addDataSetItems, updatedDataSet, setUpdatedDataSet, selectedDataSetItems, setSelectedDataSetItems } = useDataSets();

  const [agents, setAgents] = useState([]);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        setAgents(
          await getAgents(selectedClient.public_id ?? selectedClient.id)
        );
        console.log(agents);
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM AGENTS: ", selectedClient);
    if (selectedClient) {
      fetchAgents();
    }
    // eslint-disable-next-line
  }, [selectedClient]);

  useEffect(() => {
    setLocalMedia(media);
  }, [media]);

  if (mode === "select") {
    console.log("!!! SELECT MODE: ", mode);
  }

  window.edit = (public_id) => {
    NiceModal.show("edit-media-item", {
      public_id: public_id,
    }).then((updatedItem) => {
      console.log("!!! UPDATED ITEM: ", updatedItem);
      const newLocalMedia = [...localMedia];
      newLocalMedia.forEach((item) => {
        if (item.public_id === updatedItem.public_id) {
          item.name = updatedItem.name;
          item.short_title = updatedItem.short_title;
          item.summary = updatedItem.summary;
          item.description = updatedItem.description;
          item.additional_data = updatedItem.additional_data;
          item.token_count = updatedItem.token_count;
        }
      });
      setLocalMedia(newLocalMedia);
    });
  };


  window.new_media = () => {
    const agent_id = agents.length > 0 ? agents[0].id : null;
    console.log("!!! AGENT ID: ", agent_id);
    NiceModal.show("add-media", {
      agent_id,
      onSaveMedia: (m) => {
        console.log("SAVE MEDIA: ", m);
        const newMedia = [...media];
        newMedia.push(m);
        //setMedia(newMedia);
      },
      onError: (message) => {
        /*toast.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
          life: 3000,
        });*/
      },
    }).then((updatedItem) => {
      console.log("!!! UPDATED ITEM: ", updatedItem);
      const newLocalMedia = [...localMedia];
      newLocalMedia.forEach((item) => {
        if (item.public_id === updatedItem.public_id) {
          item.name = updatedItem.name;
          item.short_title = updatedItem.short_title;
          item.summary = updatedItem.summary;
          item.description = updatedItem.description;
          item.additional_data = updatedItem.additional_data;
          item.token_count = updatedItem.token_count;
        }
      });
      setLocalMedia(newLocalMedia);
    });
  };

  window.delete = (public_id, isDataSet) => {
    console.log("!!! MEDIA DELETE: ", public_id);
    if (tableRef.current) {
      const table = tableRef.current.dt();
      const row = table.row((idx, data) => data[0] === public_id);

      if (row) {
        const message = isDataSet ? "Are you sure you want to remove this item from the data set?" : "Are you sure you want to delete this media item? This action cannot be undone.";
        const confirmMessage = isDataSet ? "Yes, remove it!" : "Yes, delete it!";
        Swal.fire({
          title: message,
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: confirmMessage,
        }).then(async (result) => {
          if (result.value) {
            setDeleting(true);
            if (isDataSet) {
              Swal.close();
              Swal.fire({
                title: "Removing...",
                text: "Removing item from data set...",
                timerProgressBar: true,
                allowOutsideClick: false,
                onOpen: async () => {
                  Swal.showLoading();
                  const response = await deleteDataSetItem(updatedDataSet.public_id, public_id);
                  if (response.success) {
                    removeDataSetItem(public_id);
                    Swal.fire(
                      "Removed!",
                      response.message || "Item removed from data set.",
                      "success"
                    );
                  } else {
                    Swal.fire(
                      "Error!",
                      response.message || "Failed to remove item from data set.",
                      "error"
                    );
                    return;
                  }
                  Swal.close();
                }
              });
            } else {
              const response = await deleteMediaItem(public_id);
              console.log("!!! DELETE RESPONSE: ", response);
              if (response.success) {
                Swal.fire(
                  "Deleted!",
                  response.message || "Media item deleted successfully.",
                  "success"
                );
              }
            }
            setDeleting(false);
            const newLocalMedia = [...localMedia].filter(
              (item) => item.public_id !== public_id
            );
            setLocalMedia(newLocalMedia);
          }
        });
      }
    }
  };

  window.editMediaItem = async (mediaId) => {
    console.log("!!! SHOW MEDIA CHUNKS: ", mediaId);
    if (isDataSet) {
      const dataSetItem = await getDataSetItem(updatedDataSet?.public_id, mediaId)
      console.log("!!! DATA SET ITEM: ", dataSetItem);
    }
  }

  window.viewItemMetadata = (mediaId) => {
    const item = (localMedia || []).find((media) => media.public_id === mediaId) ?? null;
    setMetadataItem(item);
    setShowItemMetadataDialog(true);
  };

  window.previewMediaItem = (mediaId) => {
    const item = (localMedia || []).find((media) => media.public_id === mediaId) ?? null;
    setPreviewItem(item);
    setShowPreviewDialog(true);
  };

  window.viewChunks = async (mediaId, mediaTitle) => {
    console.log("!!! SHOW MEDIA CHUNKS: ", mediaId);
    if (isDataSet) {
      setMediaChunks(null);
      setChunksEmptyMessage("No chunks were returned for this item.");
      setMediaTitle(mediaTitle);
      setShowMediaChunksDialog(true);
      const results = await getDataSetItemChunks(updatedDataSet?.public_id, mediaId)
      // Log the raw payload: the envelope and field names are the first thing to check when
      // this list comes back empty.
      console.log("!!! CHUNKS RESPONSE: ", JSON.stringify(results)?.slice(0, 2000));
      if (results?.success) {
        setMediaChunks(results);
        setChunksEmptyMessage(describeChunkResponse(results));
      } else {
        swal.fire({
          title: "Error",
          text: results?.message || "Failed to fetch media chunks.",
          icon: "error",
        }).then(() => {
          setShowMediaChunksDialog(false);
        });

      }
    }
  }

  // Selection is held in a set of public_ids rather than in the DOM alone, so "select all"
  // can cover rows on other pages and the selection survives a re-render. Only the select
  // mode uses these, so non-select tables must not overwrite them (several tables can be
  // mounted at once, e.g. the media list behind the "Add Data Item" dialog).
  if (!(window.selectedDataItems instanceof Set)) {
    // Keep the globals defined so the row handlers below can never hit an undefined set.
    window.selectedDataItems = new Set();
  }
  if (mode === "select") {
    window.onSelectDataItems = onSelect;
  }

  const updateSelectionCount = () => {
    if (!selectedCountRef.current) return;
    selectedCountRef.current.textContent = `${countSelected(window.selectedDataItems).toLocaleString()} selected`;
  };

  const applySelectAll = (selected) => {
    setSelection({
      container: containerRef.current,
      ids: (localMedia || []).map((mediaItem) => mediaItem?.public_id),
      selected,
      selectionSet: window.selectedDataItems,
    });

    if (window.onSelectDataItems) {
      window.onSelectDataItems(window.selectedDataItems);
    }
    updateSelectionCount();
  };

  if (mode === "select") {
    // Used by the "Add Data Item" dialog so each session starts with nothing selected.
    // Clears the whole set (not just the listed ids) and un-checks every rendered row.
    window.resetDataItemSelection = () => {
      if (window.selectedDataItems) {
        window.selectedDataItems.clear();
      }
      setSelection({
        container: containerRef.current,
        ids: [],
        selected: false,
        selectionSet: window.selectedDataItems,
      });
      if (window.onSelectDataItems) {
        window.onSelectDataItems(window.selectedDataItems);
      }
      updateSelectionCount();
    };
  }

  // Called from the inline row handlers, so it has to live on window.
  window.toggleDataItemSelection = (button) => {
    toggleRowSelected(button?.parentNode, window.selectedDataItems);
    if (window.onSelectDataItems) {
      window.onSelectDataItems(window.selectedDataItems);
    }
    updateSelectionCount();
  };

  useEffect(() => {
    updateSelectionCount();
  });

  window.ingestDataItem = (public_id, title) => {
    // Datasets with an item metadata schema collect the metadata before ingesting, so it can be
    // validated and sent with the request.
    if (hasMetadataSchema(updatedDataSet)) {
      const item =
        (localMedia || []).find((entry) => entry.public_id === public_id) ??
        { public_id, name: title };
      setIngestItem(item);
      return;
    }

    Swal.fire({
      title: "Ingest Media",
      text: "Ingesting media item: " + title,
      timerProgressBar: true,
      onOpen: async () => {
        console.log("!!! DID OPEN: ", public_id);
        Swal.showLoading();
        // Simulate an async operation (e.g., API call)
        //
        const results = await ingestDataSetItem(updatedDataSet.public_id, public_id);
        Swal.close();
        if (results.success) {
          const item = results.item;
          console.log("!!! INGESTED ITEM: ", item);
          const updatedSelectedDataSetItems = [...selectedDataSetItems];
          // Update the item status in the selected data set items list, the item already exists in the list but with a different status, so we need to update it
          const existingItemIndex = updatedSelectedDataSetItems.findIndex((i) => i.public_id === item.public_id);
          if (existingItemIndex > -1) {
            updatedSelectedDataSetItems[existingItemIndex] = item;
          } else {
            updatedSelectedDataSetItems.push(item);
          }
          setSelectedDataSetItems(updatedSelectedDataSetItems);
        } else {
          Swal.fire({
            title: "Error",
            text: results.message || "Failed to ingest media item.",
            icon: "error",
          });
        }
      }
    });
  }

  const tableData = localMedia.map((mediaItem) => {
    tokenCount += mediaItem.token_count;
    // Rows are built from these strings, so seed the checkbox from the live selection set
    // instead of always starting out unselected.
    const isSelected = mode === "select" && !!window.selectedDataItems?.has(mediaItem.public_id);
    const fieldValues = {
      public_id: mediaItem.public_id,
      name: `<div style="font-weight: bold">${mediaItem.name}</div>`,
      short_title: `<div style="font-weight: bold">${mediaItem.short_title}</div>`,
      summary: `<div style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow-y: auto; overflow-x: hidden;">${mediaItem.summary}</div>`,
      token_count: mediaItem.token_count,
      updated_at: `<div style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow-y: auto; overflow-x: hidden; display: none">${new Date(mediaItem.updated_at).getTime()}</div>`,
      full_actions: `<div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center;" onClick="window.open('${mediaItem?.media_url ?? mediaItem.fullpath}')" class="bg-orange-400 text-white active:bg-orange-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button"><svg style="width: 20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/></svg></button><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.edit('${mediaItem.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 16px; color: black;" onClick="window.delete('${mediaItem.public_id}', ${isDataSet ? 'true' : 'false'})" class="bg-red-400 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">X</button></div>`,
      dataset_actions: `<div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 16px; color: black;" title="Preview media file" onClick="window.previewMediaItem('${mediaItem?.public_id}')" class="bg-purple-400 text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">▶</button><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: black;font-size: 20px;" onClick="window.editMediaItem('${mediaItem?.public_id}')" class="bg-orange-400 text-white active:bg-orange-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button><div style="display: ${mediaItem.ingested || mediaItem.chunk_count ? "flex" : "flex"}; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" title="Ingest data item" onClick="window.ingestDataItem('${mediaItem.public_id}','${mediaItem.name}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 512"><path fill="#000" fill-rule="evenodd" d="M426.667 64v362.667H64V192h42.666v192H384V106.667l-192-.001V64zM79.085 48.915l198.248 198.248v-76.496H320V320H170.667v-42.667h76.496L48.915 79.085z"/></svg></button></div><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 16px; color: black;" onClick="window.delete('${mediaItem.public_id}', ${isDataSet ? 'true' : 'false'})" class="bg-red-400 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">X</button></div>`,
      metadata: `<div onClick="window.viewItemMetadata('${mediaItem.public_id}')" style="text-decoration: underline; cursor: pointer;" title="View data item metadata">${summarizeMetadata(mediaItem.metadata)}${mediaItem.metadata_source ? ` · ${mediaItem.metadata_source}` : ""}</div>`,
      select_actions: `<div data-public-id="${mediaItem.public_id}" data-selected="${isSelected ? "true" : "false"}" style="display: flex; flex-direction: row;">
          <button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; background-color: ${isSelected ? SELECTED_ROW_BACKGROUND : UNSELECTED_ROW_BACKGROUND};" onClick="window.toggleDataItemSelection(this)" class="bg-green-400 text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m19.75 7.018l-9.257 9.257a1 1 0 0 1-1.414 0L4.25 11.446"/></svg></button>  
        </div>`
    };

    if (mode === "select") {
      return [
        fieldValues.updated_at,
        fieldValues.name,
        fieldValues.short_title,
        fieldValues.select_actions
      ]
    } else if (!isDataSet) {
      return [
        fieldValues.updated_at,
        fieldValues.name,
        fieldValues.short_title,
        fieldValues.summary,
        fieldValues.token_count,
        fieldValues.full_actions
      ]
    } else {
      return [
        fieldValues.updated_at,
        fieldValues.name,
        fieldValues.short_title,
        fieldValues.summary,
        fieldValues.token_count,
        mediaItem.ingested || mediaItem.chunk_count ? `<div><div>Yes</div><div onClick="window.viewChunks('${mediaItem.public_id}', '${mediaItem.name.replace("'", "\\'")}')" style="text-decoration: underline; cursor: pointer;" title="View media chunks">${mediaItem.chunk_count} chunks</div></div>` : `<div style='position: relative;'><div>No</div></div>`,
        fieldValues.metadata,
        fieldValues.dataset_actions
      ]
    }
  });

  return (
    <div ref={containerRef} style={{ width: "100%", position: "relative", paddingLeft: "20px", paddingRight: "20px" }}>
      <div style={{ fontSize: "32px", fontWeight: "bold", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        {!hideTitle ? (
          <div>Data Items</div>
        ) : null}
        {mode === "select" ? (
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", fontSize: "16px", fontStyle: "normal", fontWeight: "normal" }}>
            <Button onClick={() => applySelectAll(true)}>Select All</Button>
            <Button onClick={() => applySelectAll(false)}>Deselect All</Button>
            <span ref={selectedCountRef} style={{ fontStyle: "italic" }} />
          </div>
        ) : null}
        <div style={{ fontSize: "16px", fontStyle: "italic", fontWeight: "normal" }}>
          {localMedia.length.toLocaleString()} items ({tokenCount.toLocaleString()} tokens)
        </div>
        {
          !hideButtons ? (
            <div style={{ position: "relative", display: "flex", flexDirection: "row", gap: "10px" }}>
              <Button
                onClick={() => {
                  setShowDialog(true);
                }}
              >+ Create Data Item</Button>
              {
                showAddExisting ? (
                  <Button
                    onClick={() => {
                      setShowExistingDialog(true);
                    }}
                  >+ Add Existing Media</Button>
                ) : null
              }
            </div>
          ) : null}
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[0, "desc"]],
        }}
      >
        <thead>
          <tr>
            {/*<th>ID</th>*/}
            <th style={{ width: "0px" }}></th>
            <th style={{ minWidth: "200px" }}>Name</th>
            <th style={{ minWidth: "100px" }}>Short Title</th>
            {mode !== "select" ? (
              <>
                <th style={{ minWidth: "400px" }}>Summary</th>
                <th>Tokens</th>
                {isDataSet ? (
                  <>
                    <th>Ingested</th>
                    <th style={{ minWidth: "90px" }}>Metadata</th>
                  </>
                ) : null}
              </>
            ) : null}
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
      <NewDataDialog
        show={showDialog}
        onClose={() => setShowDialog(false)}
        onSave={async (newDataItem) => {
          const results = await saveDataSetItem(updatedDataSet.public_id, newDataItem.public_id);
          if (!results.success) {
            Swal.fire({
              title: "Error",
              text: "There was an error saving the data item. Please try again.",
              icon: "error",
              button: "OK",
              confirmButtonText: "OK",
            });
            return;
          }

          if (results?.items.length > 0) {
            addDataSetItems(results.items);
          }

          if (onSelectSave) {
            onSelectSave([newDataItem.public_id]);
          }
        }}
        okText="Save"
        closeText="Close"
      />
      <ExistingDataDialog
        show={showExistingDialog}
        onClose={() => setShowExistingDialog(false)}
        onOK={() => setShowExistingDialog(false)}
        onSave={onSelectSave ? (items) => {
          onSelectSave(items);
          setShowExistingDialog(false);
        } : null}
        okText="Save"
        closeText="Close"
      />
      <MediaChunksDialog
        show={showMediaChunksDialog}
        mediaChunks={mediaChunks}
        mediaTitle={mediaTitle}
        emptyMessage={chunksEmptyMessage}
        onClose={() => setShowMediaChunksDialog(false)}
        onOK={() => setShowMediaChunksDialog(false)}
        okText="Save"
        closeText="Close"
      />
      <ItemMetadataDialog
        show={showItemMetadataDialog}
        item={metadataItem}
        onClose={() => setShowItemMetadataDialog(false)}
        onUseAsSchema={(schema) => {
          if (!updatedDataSet) return;
          // Sets it on the dataset record; the dataset's Save Changes persists it.
          setUpdatedDataSet({ ...updatedDataSet, metadata_schema: schema });
        }}
        onSaved={(publicId, metadata) => {
          // Reflect the new metadata in the row straight away, so the summary column updates
          // without refetching the whole list.
          setMetadataItem((current) => (current?.public_id === publicId ? { ...current, metadata } : current));
          setLocalMedia((current) =>
            (current || []).map((media) => (media.public_id === publicId ? { ...media, metadata } : media))
          );
        }}
      />
      <IngestMetadataDialog
        show={Boolean(ingestItem)}
        item={ingestItem}
        dataSet={updatedDataSet}
        onClose={() => setIngestItem(null)}
        onIngested={(item) => {
          if (!item) return;
          setLocalMedia((current) =>
            (current || []).map((entry) => (entry.public_id === item.public_id ? { ...entry, ...item } : entry))
          );
          setSelectedDataSetItems((current) =>
            (current || []).map((entry) => (entry.public_id === item.public_id ? { ...entry, ...item } : entry))
          );
        }}
      />
      <MediaPreviewDialog
        show={showPreviewDialog}
        item={previewItem}
        onClose={() => setShowPreviewDialog(false)}
      />
      {
        deleting ? (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "10px",
              transform: "translate(-50%, -50%)",
              zIndex: 1000,
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              border: "1px solid #ccc",
            }}
          >
            <i
              className="fas fa-circle-notch fa-spin"
              style={{ fontSize: "50px", textAlign: "center" }}
            ></i>
            <div style={{ fontSize: "20px", fontWeight: "bold" }}>
              Deleting...
          </div>
          </div>
        ) : null
      }
    </div >
  );
};

export default MediaTable;
